<!-- @format -->
 @if(optionVariant() === 'selectable') {
	<plp-components-fulfillment-filter-selectable
		[sectionHeaders]="selectableSections()"
		[currentSelectedOptions]="selectedOptions()"
		[fulfillmentFacets]="fulfillmentFacets()"
		[fulfillmentFacetsEnabled]="fulfillmentFacetsEnabled()"
		[sameDayDeliveryEnabled]="sameDayDeliveryEnabled()"
		[disabled]="disabled()"
		(changeLocationAndStoreName)="selectUserZipCodeAndStoreInfo($event)"
		(selectedOption)="setSelectedFilter($event)">
	</plp-components-fulfillment-filter-selectable>
 } @else {
	<plp-components-fulfillment-filter-chip
		[locationInfo]="chipLocationInfo()"
		[fulfillmentFacets]="fulfillmentFacets()"
		[fulfillmentFacetsEnabled]="fulfillmentFacetsEnabled()"
		[exposedFiltersEnabled]="exposedFiltersEnabled()"
		[sameDayDeliveryEnabled]="sameDayDeliveryEnabled()"
		[moveFulfillmentToFilters]="moveFulfillmentToFilters()"
		[disabled]="disabled()"
		[isMobile]="isMobile()"
		[mobileSelectionPosition]="mobileSelectionPosition()"
		(changeLocationAndStoreName)="selectUserZipCodeAndStoreInfo($event)"
		(selectedOption)="setSelectedFilter($event)">
	</plp-components-fulfillment-filter-chip>
}
